import { user } from "./user";

let _permissions = {};

export function setPermissions (remotePermissions) {
    _permissions = remotePermissions;
}

export function can (permission) {
    if (['developer'].includes(user().type)) {
        return true;
    }
    let permitted = false;
    permission.split('|').forEach(perm => {
        permitted = permitted || _permissions.hasOwnProperty(perm);
    });
    return permitted;
}
